// Mock data for the deposit security website

export const mockBlogPosts = [
  {
    id: '1',
    title: {
      fr: 'Les 7 erreurs qui vous font perdre votre dépôt de garantie',
      en: '7 Mistakes That Cost You Your Security Deposit'
    },
    excerpt: {
      fr: 'Découvrez les erreurs les plus courantes qui peuvent vous coûter des milliers d\'euros et comment les éviter.',
      en: 'Discover the most common mistakes that can cost you thousands of euros and how to avoid them.'
    },
    date: '2025-01-15',
    category: {
      fr: 'Conseils',
      en: 'Tips'
    },
    image: 'https://images.unsplash.com/photo-1521783593447-5702b9bfd267?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhaXJibmIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjQ4NDc5NjV8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: '2',
    title: {
      fr: 'Caution, dépôt de garantie, arrhes : les différences',
      en: 'Deposit, Security Deposit, Down Payment: The Differences'
    },
    excerpt: {
      fr: 'Comprendre les différences juridiques entre ces termes pour mieux protéger vos revenus locatifs.',
      en: 'Understand the legal differences between these terms to better protect your rental income.'
    },
    date: '2025-01-10',
    category: {
      fr: 'Juridique',
      en: 'Legal'
    },
    image: 'https://images.unsplash.com/photo-1686213331025-de65716dcab3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhaXJibmIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjQ4NDc5NjV8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: '3',
    title: {
      fr: 'Comment répondre à un locataire qui refuse les retenues',
      en: 'How to Respond to a Tenant Refusing Deductions'
    },
    excerpt: {
      fr: 'Guide pratique avec modèles de réponse pour gérer efficacement les contestations de locataires.',
      en: 'Practical guide with response templates to effectively handle tenant disputes.'
    },
    date: '2025-01-05',
    category: {
      fr: 'Guides',
      en: 'Guides'
    },
    image: 'https://images.unsplash.com/photo-1715985160053-d339e8b6eb94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhaXJibmIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjQ4NDc5NjV8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: '4',
    title: {
      fr: 'Réglementation 2025 : Ce qui change pour les locations saisonnières',
      en: '2025 Regulations: What\'s Changing for Short-Term Rentals'
    },
    excerpt: {
      fr: 'Mise à jour complète sur les nouvelles réglementations et leur impact sur la gestion de vos dépôts.',
      en: 'Complete update on new regulations and their impact on managing your deposits.'
    },
    date: '2025-01-02',
    category: {
      fr: 'Actualités',
      en: 'News'
    },
    image: 'https://images.unsplash.com/photo-1700884597572-45ea007196a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHx2YWNhdGlvbiUyMHJlbnRhbHxlbnwwfHx8fDE3NjQ4NDc5NzZ8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: '5',
    title: {
      fr: 'Check-list complète pour un état des lieux parfait',
      en: 'Complete Checklist for a Perfect Property Inspection'
    },
    excerpt: {
      fr: 'Tous les points à vérifier et photographier pour sécuriser votre dépôt de garantie à 100%.',
      en: 'All the points to check and photograph to secure your security deposit 100%.'
    },
    date: '2024-12-28',
    category: {
      fr: 'Outils',
      en: 'Tools'
    },
    image: 'https://images.unsplash.com/photo-1590725175785-de025cc60835?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHx2YWNhdGlvbiUyMHJlbnRhbHxlbnwwfHx8fDE3NjQ4NDc5NzZ8MA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: '6',
    title: {
      fr: 'Modèle de clause dépôt de garantie pour bail saisonnier',
      en: 'Security Deposit Clause Template for Seasonal Lease'
    },
    excerpt: {
      fr: 'Téléchargez notre modèle gratuit de clause juridiquement solide pour protéger votre dépôt.',
      en: 'Download our free legally sound clause template to protect your deposit.'
    },
    date: '2024-12-20',
    category: {
      fr: 'Modèles',
      en: 'Templates'
    },
    image: 'https://images.unsplash.com/photo-1715985160020-d8cd6fdc8ba9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBhaXJibmIlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NjQ4NDc5NjV8MA&ixlib=rb-4.1.0&q=85'
  }
];

export const mockServices = [
  {
    id: 'pack-modeles',
    title: {
      fr: 'Pack Modèles Propriétaire',
      en: 'Owner Templates Pack'
    },
    price: '147',
    description: {
      fr: 'Tous les documents légaux dont vous avez besoin pour sécuriser vos locations',
      en: 'All the legal documents you need to secure your rentals'
    },
    features: {
      fr: [
        'Modèle de bail saisonnier blindé',
        'Modèles d\'emails de mise en demeure',
        'Courriers AR pour retenue sur dépôt',
        'Protocole de remise en état',
        'Check-list d\'état des lieux complet',
        'Guide juridique vulgarisé'
      ],
      en: [
        'Reinforced seasonal lease template',
        'Formal notice email templates',
        'Registered mail for deposit withholding',
        'Refurbishment protocol',
        'Complete property inspection checklist',
        'Simplified legal guide'
      ]
    },
    popular: true
  },
  {
    id: 'audit-express',
    title: {
      fr: 'Audit Express de votre contrat',
      en: 'Express Contract Audit'
    },
    price: '197',
    description: {
      fr: 'Analyse personnalisée de votre bail pour identifier les faiblesses',
      en: 'Personalized analysis of your lease to identify weaknesses'
    },
    features: {
      fr: [
        'Analyse complète de votre bail actuel',
        'Rapport vidéo ou PDF de 30 minutes',
        'Identification des points faibles',
        'Recommandations personnalisées',
        'Vérification des clauses légales',
        'Réponse sous 48h'
      ],
      en: [
        'Complete analysis of your current lease',
        '30-minute video or PDF report',
        'Identification of weak points',
        'Personalized recommendations',
        'Legal clause verification',
        'Response within 48 hours'
      ]
    },
    popular: false
  },
  {
    id: 'accompagnement-litige',
    title: {
      fr: 'Accompagnement Litige',
      en: 'Dispute Support'
    },
    price: '497',
    description: {
      fr: 'Support complet pour récupérer votre dépôt en cas de litige',
      en: 'Complete support to recover your deposit in case of dispute'
    },
    features: {
      fr: [
        'Analyse approfondie de votre dossier',
        'Stratégie de résolution personnalisée',
        'Modèles de courriers personnalisés',
        'Support email illimité pendant 30 jours',
        'Guide étape par étape',
        'Suivi jusqu\'à résolution'
      ],
      en: [
        'In-depth case analysis',
        'Personalized resolution strategy',
        'Customized letter templates',
        'Unlimited email support for 30 days',
        'Step-by-step guide',
        'Follow-up until resolution'
      ]
    },
    popular: false
  }
];

export const mockTestimonials = [
  {
    id: '1',
    name: 'Marie L.',
    location: {
      fr: 'Nice, France',
      en: 'Nice, France'
    },
    text: {
      fr: 'Grâce aux modèles fournis, j\'ai pu récupérer 100% de mon dépôt de garantie de 1 800€. Le courrier de mise en demeure était parfait !',
      en: 'Thanks to the templates provided, I was able to recover 100% of my €1,800 security deposit. The formal notice letter was perfect!'
    },
    rating: 5,
    amount: '1 800€'
  },
  {
    id: '2',
    name: 'Thomas B.',
    location: {
      fr: 'Paris, France',
      en: 'Paris, France'
    },
    text: {
      fr: 'L\'audit de mon contrat a révélé des failles importantes. J\'ai corrigé et je n\'ai plus eu de problèmes de contestation depuis 6 mois.',
      en: 'The audit of my contract revealed significant flaws. I corrected them and haven\'t had any dispute issues for 6 months.'
    },
    rating: 5,
    amount: null
  },
  {
    id: '3',
    name: 'Sophie M.',
    location: {
      fr: 'Lyon, France',
      en: 'Lyon, France'
    },
    text: {
      fr: 'Accompagnement top pour un litige complexe avec un locataire étranger. Récupération de 2 400€ en 3 semaines !',
      en: 'Excellent support for a complex dispute with a foreign tenant. Recovered €2,400 in 3 weeks!'
    },
    rating: 5,
    amount: '2 400€'
  },
  {
    id: '4',
    name: 'Jean-Pierre D.',
    location: {
      fr: 'Bordeaux, France',
      en: 'Bordeaux, France'
    },
    text: {
      fr: 'Les check-lists sont ultra complètes. Maintenant mes états des lieux sont inattaquables. Un investissement qui vaut largement le coup.',
      en: 'The checklists are extremely comprehensive. Now my property inspections are bulletproof. An investment well worth it.'
    },
    rating: 5,
    amount: null
  }
];

export const mockFAQs = [
  {
    id: '1',
    question: {
      fr: 'Est-ce un service d\'avocat ?',
      en: 'Is this a lawyer service?'
    },
    answer: {
      fr: 'Non, nous proposons des modèles de documents et des conseils pédagogiques pour vous aider à gérer vos dépôts de garantie. Nous ne représentons pas nos clients en justice. Pour une représentation légale, consultez un avocat.',
      en: 'No, we provide document templates and educational advice to help you manage your security deposits. We do not represent clients in court. For legal representation, consult a lawyer.'
    }
  },
  {
    id: '2',
    question: {
      fr: 'Combien de temps pour récupérer mon dépôt ?',
      en: 'How long to recover my deposit?'
    },
    answer: {
      fr: 'Cela dépend de la situation, mais avec nos modèles et stratégies, la plupart de nos clients récupèrent leur dépôt en 2 à 4 semaines. Les cas complexes peuvent prendre plus de temps.',
      en: 'It depends on the situation, but with our templates and strategies, most of our clients recover their deposit in 2 to 4 weeks. Complex cases may take longer.'
    }
  },
  {
    id: '3',
    question: {
      fr: 'Que se passe-t-il si mon locataire est à l\'étranger ?',
      en: 'What if my tenant is abroad?'
    },
    answer: {
      fr: 'Nos modèles sont adaptés pour les situations internationales. Nous incluons des stratégies spécifiques pour traiter avec des locataires étrangers et des réservations via plateformes (Airbnb, Booking).',
      en: 'Our templates are adapted for international situations. We include specific strategies for dealing with foreign tenants and bookings via platforms (Airbnb, Booking).'
    }
  },
  {
    id: '4',
    question: {
      fr: 'Les modèles sont-ils conformes à la loi française ?',
      en: 'Are the templates compliant with French law?'
    },
    answer: {
      fr: 'Oui, tous nos modèles sont basés sur le Code civil, le Code du tourisme et la réglementation en vigueur en 2025. Ils sont régulièrement mis à jour pour refléter les changements législatifs.',
      en: 'Yes, all our templates are based on the Civil Code, Tourism Code and current 2025 regulations. They are regularly updated to reflect legislative changes.'
    }
  },
  {
    id: '5',
    question: {
      fr: 'Puis-je déduire ces frais en charges ?',
      en: 'Can I deduct these fees as expenses?'
    },
    answer: {
      fr: 'Ces frais peuvent potentiellement être déduits comme frais de gestion locative. Nous vous recommandons de consulter votre comptable pour confirmer selon votre situation fiscale spécifique.',
      en: 'These fees can potentially be deducted as rental management expenses. We recommend consulting your accountant to confirm based on your specific tax situation.'
    }
  },
  {
    id: '6',
    question: {
      fr: 'Offrez-vous une garantie ?',
      en: 'Do you offer a guarantee?'
    },
    answer: {
      fr: 'Oui, nous offrons une garantie satisfait ou remboursé de 30 jours sur le Pack Modèles. Si vous n\'êtes pas satisfait, contactez-nous pour un remboursement complet.',
      en: 'Yes, we offer a 30-day money-back guarantee on the Templates Pack. If you\'re not satisfied, contact us for a full refund.'
    }
  }
];
